import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { stushiftcreate, stushiftdelete, stushiftdetail, stushiftlist, stushiftupdate, stushiftvalidate } from "../../../services/master";
export const Shift = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [Catid, setID] = useState(0);
  const [name, setName] = useState("");
  const [intime, setIntime] = useState("");
  const [outtime, setOuttime] = useState("");

  
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    funlist();
  }, []);

  function funlist() {
    setFilterProduct([]);
    stushiftlist().then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data);
      }
    });
  }
  const columnDefs = [
    {
      headerName: "Shift",
      width: 470,
      field: "shift_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
        headerName: "In Time",
        width: 100,
        field: "InTime",
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: true,
        cellStyle: { textAlign: "left" },
      },
      {
        headerName: "Out Time",
        width: 100,
        field: "OutTime",
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: true,
        cellStyle: { textAlign: "left" },
      },

    // {
    //   headerName: "Status",
    //   width: 150,
    //   field: "active",
    //   sortable: true,
    //   resizable: true,
    //   filter: true,
    //   floatingFilter: true,
    //   cellRenderer: function (params) {
    //     return (
    //       <div className="text-center">
    //         <label className="custom-switch mb-0">
    //           <input
    //             type="checkbox"
    //             name="custom-switch-checkbox"
    //             className="custom-switch-input"
    //             checked={params.value === 1 ? true : false}
    //             onChange={() => handleSwitch(params)}
    //           />

    //           <span className="custom-switch-indicator"></span>
    //         </label>
    //       </div>
    //     );
    //   },
    // },

    {
      headerName: "Actions",
      width: 180,
      field: "id",
      resizable: true,
      filter: false,
      // headerClass: "ag-center-aligned-header",
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewshow(params.value)}
              className="btn-sm btn-info"
            >
              <i className="fa fa-edit"></i>
            </a>
          </div>
        );
      },
    },
  ];

  function handleSwitch(list) {
    if (list.value === 1) {
      Swal.fire({
        text: "Are you sure want to Inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Inactive",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("id", list.data.id);
          temp.append("status", 0);

          stushiftdelete(temp).then((response) => {
            if (response.status === true) {
              funlist();
            }
          });
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Active?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Active",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("id", list.data.id);
          temp.append("status", 1);

          stushiftdelete(temp).then((response) => {
            if (response.status === true) {
              funlist();
            }
          });
        }
      });
    }
  }

  const [show, setShow] = useState(false);
  function handleshow() {
    setID(0);
    setName("");
    setIntime("");
    setOuttime("");
    
    setErrorMessage("");
    setShow(true);
  }

  function handleclose() {
    setID(0);
    setName("");
    setIntime("");
    setOuttime("");
    
    setErrorMessage("");
    setShow(false);
  }

  function viewshow(vid) {
    setID(vid);
    setName("");
    setIntime("");
    setOuttime("");
    setShow(true);
    
    setErrorMessage("");
    stushiftdetail(vid).then((response) => {
      if (response.status === true) {
        setName(response.data.shift_name);
        setIntime(response.data.InTime);
        setOuttime(response.data.OutTime);
      }
    });
  }

  

  function Submitage() {
    setErrorMessage("");

    if (name !== "") {
        const temp = new FormData();
    temp.append("name", name);
    temp.append("id", Catid);

    stushiftvalidate(temp).then((response) => {
      if (response.status === false) {
        
        setErrorMessage(response.message);
      }else{
        const tempData = new FormData();
        tempData.append("name", name);
        tempData.append("in_time", intime);
        tempData.append("out_time", outtime);

        tempData.append("user_id", localStorage.getItem("UID"));
        if (Catid === 0) {
          stushiftcreate(tempData).then((response) => {
            if (response.status === true) {
              handleclose();
              funlist();
              toast.success(response.message);
            } else {
              setErrorMessage(response.data.message);
            }
          });
        } else {
          tempData.append("id", Catid);
          stushiftupdate(tempData).then((response) => {
            if (response.status === true) {
              handleclose();
              funlist();
              toast.success(response.message);
            } else {
              setErrorMessage(response.data.message);
            }
          });
        }
      }
    });

       
    } else {
      setErrorMessage("Please Enter Shift");
    }
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Shift List</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a >Master</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
            Shift
            </li>
          </ol>
        </div>
      </div>
      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a
                    onClick={handleshow}
                    variant="success"
                    type="button"
                    className="btn my-1 me-2 btn-success tx-teko"
                  >
                    {" "}
                    Add
                  </a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>

              <Modal show={show}>
                <Modal.Header>
                  {Catid === 0 ? <h4>Add Shift</h4> : <h4>Shift Detail</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Shift <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Enter Your Shift"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          
                        />
                      </div>
                    </Col>

                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          In Time <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="time"
                          placeholder="Enter Your In Time"
                          value={intime}
                          onChange={(e) => setIntime(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Out Time <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="time"
                          placeholder="Enter Your Out Time"
                          value={outtime}
                          onChange={(e) => setOuttime(e.target.value)}
                        />
                      </div>
                    </Col>

                    {errorMessage !== "" && (
                      <span className="text-danger">{errorMessage}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {Catid === 0 ? (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Submit
                    </a>
                  ) : (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Update
                    </a>
                  )}
                  <a
                    className="btn btn-next btn-secondary"
                    style={{ float: "right" }}
                    onClick={handleclose}
                  >
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};
